// extracted by mini-css-extract-plugin
module.exports = {"zpChip":"ZpChip_zpChip__Jmw14","whiteChip":"ZpChip_whiteChip__CigpQ"};